import { render } from "./LawFirmBotGrid.vue?vue&type=template&id=e199e30e&ts=true"
import script from "./LawFirmBotGrid.vue?vue&type=script&lang=ts"
export * from "./LawFirmBotGrid.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__